import { useEffect, useState } from "react";
import { PanelGenerico } from "../../../components/generic/PanelGenerico";
import { TagDefault } from "../../../components/indicadores/Tags";
import COLORES from "../../../utils/theme/colores";
import IPERCService from "../../../services/IPERCService";
import { Icon, Spinner } from "@fluentui/react";

interface AdjuntosHistoricoProps {
  urlAdjunto: string[];
  isOpen: boolean;
  dismiss: (
    ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined
  ) => void;
}

//#region
// eslint-disable-next-line jsx-a11y/alt-text
const Foto = ({ ruta }) => (
  <img
    src={`${ruta}`}
    style={{
      maxWidth: 400,
      maxHeight: 500,
      margin: 20,
      padding: 10,
      border: `solid 1px ${COLORES.Bases.primary}`,
      borderRadius: 10,
    }}
  />
);

const PanelAdjuntos: React.FunctionComponent<AdjuntosHistoricoProps> = (
  prop
) => {
  const [listImg64, setListImg64] = useState<string[]>([]);

  const [hiddenSpinner, setHiddenSpinner] = useState(false);
  const [hiddenData, setHiddenData] = useState(true);

  const listaImg = () => {
    const newList: IListLink = { listUrlBase: [] };
    if (prop.urlAdjunto.length !== 0) {
      newList.listUrlBase = prop.urlAdjunto;
    }
    IPERCService.listarAdjuntoHistoria(newList)
      .then((res) => {
        // console.log(res.data)
        setListImg64(res.data);
        setHiddenSpinner(true);
        setHiddenData(false);
      })
      .catch((e) => {
        alert(e);
      });
  };

  useEffect(() => {
    setHiddenData(true);
    if (prop.isOpen) {
      setHiddenSpinner(false);
      listaImg();
    }
  }, [prop.isOpen]);

  return (
    <>
      <PanelGenerico
        isOpen={prop.isOpen}
        onDismiss={prop.dismiss}
        enabledFooter={true}>
        {/* {prop.urlAdjunto.map((url, i) => {
                return (
                  <div key={i}>
                    <TagDefault bodyMenssaje={`Foto : ${i + 1}`}></TagDefault>
                    {/* {url} * /}
                    <Foto ruta={url}></Foto>
                  </div>
                );
              })} */}
        <div hidden={hiddenSpinner}>
          <Spinner></Spinner>
        </div>

        <div hidden={hiddenData}>
          {listImg64.map((base64Data, i) => {
            return (
              <div key={i}>
                <TagDefault bodyMenssaje={`Adjunto :`}></TagDefault>
                {/* <Foto ruta={`data:image/${"png"};base64,${base64Data}`}></Foto> */}
                <br />
                {base64Data !== "" && (
                  <a
                    href={base64Data}
                    download="file.pdf"
                    style={{ color: "black", textDecoration: "none" }}>
                    <Icon
                      iconName="Download"
                      style={{ cursor: "pointer", color: "black" }}
                    />
                    Descargar
                  </a>
                )}
                <br />
                <br />
                <embed
                  src={base64Data}
                  type="application/pdf"
                  width="100%"
                  height="600px"
                />
              </div>
            );
          })}
        </div>
      </PanelGenerico>
    </>
  );
};

export default PanelAdjuntos;
//#endregion

export interface IListLink {
  listUrlBase: string[];
}
